import { render, staticRenderFns } from "./PageInicial.vue?vue&type=template&id=70cb9f9a&scoped=true"
import script from "./PageInicial.vue?vue&type=script&lang=js"
export * from "./PageInicial.vue?vue&type=script&lang=js"
import style0 from "./PageInicial.vue?vue&type=style&index=0&id=70cb9f9a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70cb9f9a",
  null
  
)

export default component.exports